import { render, staticRenderFns } from "./ChatRecommended.vue?vue&type=template&id=e0fc8f64&scoped=true"
import script from "./ChatRecommended.vue?vue&type=script&lang=js"
export * from "./ChatRecommended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fc8f64",
  null
  
)

export default component.exports